(function () {
  const DEBUG = true; // op true zetten om te debuggen

  function logDebug(...args) {
    if (DEBUG) console.log("[Instelkosten]", ...args);
  }

  function logError(...args) {
    console.error("[Instelkosten]", ...args);
  }

  logDebug("script geladen");

  const FEE_LOW = 52731020312922; // variant-id voor 30-49.99 m2
  const FEE_HIGH = 52731030143322; // variant-id voor 0-29.99 m2
  const FEE_KANTPLANK_PIECES = 54292982628698; // variant-id voor kantplank per stuk

  const FEE_DEPOSIT = 52900946215258; // variant-id voor statiegeld (oud/default)
  const FEE_DEPOSIT_18 = 53840716726618; // variant-id voor statiegeld 18 euro
  const FEE_DEPOSIT_30 = 52900946215258; // variant-id voor statiegeld 30 euro
  const FEE_DEPOSIT_45 = 54432319603034; // variant-id voor statiegeld 45 euro (pallet)
  const FEE_DEPOSIT_80 = 53840716759386; // variant-id voor statiegeld 80 euro
  const FEE_DEPOSIT_50 = 54117680939354; // variant-id voor statiegeld 50 euro
  const FEE_DEPOSIT_120 = 54387745980762; // variant-id voor statiegeld 120 euro

  const KANTPLANK_PRODUCT_ID = 10891243979098; // product-id voor kantplank stuk-fee trigger

 // Producten met afwijkende instelkosten-staffel:
// 0 - 49.99 m² → 1x FEE_LOW (dus géén HIGH-staffel onder de 30 m²)
const SPECIAL_FEE_LOW_PRODUCT_IDS = new Set([
  10914925674842,
  10914925609306,
  10914925412698,
  10933341389146,
  10933340078426,
  10933339914586,
  10933339259226,
]);

  // Alle bekende fee/deposit variant-ids op één plek (voor skip-check)
  const FEE_VARIANT_IDS = new Set([
    FEE_LOW,
    FEE_HIGH,
    FEE_KANTPLANK_PIECES,
    FEE_DEPOSIT,
    FEE_DEPOSIT_18,
    FEE_DEPOSIT_30,
    FEE_DEPOSIT_45,
    FEE_DEPOSIT_80,
    FEE_DEPOSIT_50,
    FEE_DEPOSIT_120,
  ]);

  let isUpdating = false; // voorkomt dubbele /cart.js calls en loops

  // Zoek fee-line item voor een bepaalde fee-variant
  function findFeeItem(cart, variantId) {
    return cart.items.find((i) => i.variant_id === variantId) || null;
  }

  // Helper functie om breedte uit calculator JSON te halen
  function getWidthFromCalculatorJson(item) {
    logDebug("=== START getWidthFromCalculatorJson ===");
    logDebug("Item properties:", item.properties);

    try {
      // Probeer verschillende mogelijke property namen
      const calculatorJson =
        item.properties["calculator_profile_json"] ||
        item.properties["calculator_json"] ||
        item.properties["Calculator JSON"] ||
        item.properties["_calculator_json"] ||
        item.properties["calculator-json"];

      logDebug("Calculator JSON raw value:", calculatorJson);
      logDebug("Calculator JSON type:", typeof calculatorJson);

      if (!calculatorJson) {
        logDebug("Geen calculator JSON gevonden in properties");
        logDebug("=== END getWidthFromCalculatorJson (null) ===");
        return null;
      }

      // Parse de JSON als het een string is
      let data;
      if (typeof calculatorJson === "string") {
        logDebug("Parsing calculator JSON string...");
        data = JSON.parse(calculatorJson);
        logDebug("Parsed data:", data);
      } else {
        logDebug("Calculator JSON is al een object");
        data = calculatorJson;
      }

      // Zoek naar fixed width (in meters)
      logDebug("Zoeken naar width in data...");
      logDebug("data.fixed_width_m:", data.fixed_width_m);
      logDebug("data.fixedWidthM:", data.fixedWidthM);
      logDebug("data.fixed_width:", data.fixed_width);
      logDebug("data.width_m:", data.width_m);
      logDebug("data.widthM:", data.widthM);
      logDebug("data.width:", data.width);

      const widthM =
        data.fixed_width_m ||
        data.fixedWidthM ||
        data.fixed_width ||
        data.width_m ||
        data.widthM ||
        data.width;

      logDebug("Gevonden widthM:", widthM);
      logDebug("widthM type:", typeof widthM);
      logDebug("isNaN(widthM):", isNaN(widthM));

      if (widthM && !isNaN(widthM)) {
        const result = parseFloat(widthM);
        logDebug("=== END getWidthFromCalculatorJson (success) ===");
        logDebug("Return value:", result);
        return result;
      }

      logDebug("widthM is invalid of niet gevonden");
      logDebug("=== END getWidthFromCalculatorJson (null) ===");
      return null;
    } catch (err) {
      logError("Fout bij parsen calculator JSON:", err);
      logError("Error stack:", err.stack);
      logDebug("=== END getWidthFromCalculatorJson (error) ===");
      return null;
    }
  }

  // Groepeer tagged items per product_id en bereken totale m2 per product
  function calculateFeeRequirements(cart) {
    const groups = {}; // { product_id: totale_m2 }

    cart.items.forEach((item) => {
      // Sla fee/deposit variants zelf over
      if (FEE_VARIANT_IDS.has(item.variant_id)) return;

      const isSpecialProduct = SPECIAL_FEE_LOW_PRODUCT_IDS.has(item.product_id);
      const hasInstelkostenProp =
        item.properties && item.properties["instelkosten"] === "yes";

      // Speciale producten krijgen altijd instelkosten, ook zonder de property
      if (hasInstelkostenProp || isSpecialProduct) {
        logDebug("=====================================================");
        logDebug("PRODUCT MET INSTELKOSTEN:", item.title);
        logDebug(
          "Staffel:",
          isSpecialProduct ? "SPECIAAL (0-49.99 → LOW)" : "standaard",
        );
        logDebug("=====================================================");

        const pid = item.product_id;

        // Haal lengte uit properties (in mm)
        const lengthMm = item.properties["Lengte (mm)"];
        logDebug("Lengte (mm) uit properties:", lengthMm);

        if (!lengthMm || isNaN(lengthMm)) {
          logDebug("⚠️ Geen geldige lengte gevonden voor item:", item);
          return;
        }

        // Converteer mm naar m
        const lengthM = parseFloat(lengthMm) / 1000;
        logDebug("Lengte omgerekend naar meters:", lengthM);

        // Haal breedte op uit calculator JSON, gebruik 0.5 als fallback
        const widthM = getWidthFromCalculatorJson(item) || 0.5;
        logDebug("Uiteindelijke gebruikte breedte (m):", widthM);
        logDebug(
          "Breedte bron:",
          widthM !== 0.5 ? "✓ calculator JSON" : "⚠️ default fallback (0.5m)",
        );

        // Bereken m2 (lengte in m * breedte in m)
        const m2 = lengthM * widthM;
        logDebug("Berekening m² per item:", lengthM, "x", widthM, "=", m2);

        // Vermenigvuldig met quantity
        const totalM2 = m2 * item.quantity;
        logDebug("Totaal m² (x quantity):", m2, "x", item.quantity, "=", totalM2);

        if (!groups[pid]) groups[pid] = 0;
        groups[pid] += totalM2;

        logDebug("Samenvatting:", {
          product: item.title,
          lengthMm,
          lengthM,
          widthM: widthM,
          widthSource: widthM !== 0.5 ? "calculator JSON" : "default (0.5m)",
          m2PerItem: m2,
          quantity: item.quantity,
          totalM2,
          groupTotal: groups[pid],
        });
        logDebug("=====================================================");
      }
    });

    let lowRequired = 0; // 30-49.99 m2
    let highRequired = 0; // 0-29.99 m2

    Object.keys(groups).forEach((pid) => {
      const m2 = groups[pid];
      // Object.keys geeft strings terug, dus terug naar number voor de Set-check
      const isSpecialProduct = SPECIAL_FEE_LOW_PRODUCT_IDS.has(Number(pid));
      logDebug("Product", pid, "heeft totaal", m2, "m²");

      if (isSpecialProduct) {
        // Afwijkende staffel: 0-49.99 m² → altijd LOW fee
        if (m2 >= 0 && m2 < 50) {
          lowRequired += 1;
          logDebug("→ krijgt LOW fee (speciaal product, 0-49.99 m²)");
        } else {
          logDebug("→ GEEN fee (speciaal product, >= 50 m²)");
        }
        return;
      }

      if (m2 >= 0 && m2 < 30) {
        highRequired += 1; // dit product krijgt 1x high fee (0-29.99 m2)
        logDebug("→ krijgt HIGH fee (0-29.99 m²)");
      } else if (m2 >= 30 && m2 < 50) {
        lowRequired += 1; // dit product krijgt 1x low fee (30-49.99 m2)
        logDebug("→ krijgt LOW fee (30-49.99 m²)");
      } else {
        // >= 50 m2: geen fee voor dit product
        logDebug("→ GEEN fee (>= 50 m²)");
      }
    });

    logDebug("fee requirements per product:", {
      groups,
      lowRequired,
      highRequired,
    });

    return { lowRequired, highRequired };
  }

  /**
   * Bepaal per statiegeld-variant hoeveel unieke producten dat bedrag nodig hebben.
   *
   * Regels:
   *  1. Heeft het product een 'statiegeld_amount' property (18 / 30 / 45 / 50 / 80 / 120)?
   *     → gebruik de bijpassende variant, ongeacht de 'statiegeld' property.
   *  2. Geen 'statiegeld_amount' maar 'statiegeld' === 'yes'?
   *     → gebruik de standaard/oud FEE_DEPOSIT variant.
   *  3. Geen van beide → geen statiegeld voor dit product.
   */
  function calculateDepositRequirements(cart) {
    // Houd per variant bij welke product-ids dat bedrag nodig hebben
    const productsByVariant = {
      [FEE_DEPOSIT_18]: new Set(),
      [FEE_DEPOSIT_30]: new Set(),
      [FEE_DEPOSIT_45]: new Set(),
      [FEE_DEPOSIT_50]: new Set(),
      [FEE_DEPOSIT_80]: new Set(),
      [FEE_DEPOSIT_120]: new Set(),
      [FEE_DEPOSIT]: new Set(), // default / oud
    };

    // Mapping van string-bedrag naar variant-id
    const amountToVariant = {
      18: FEE_DEPOSIT_18,
      30: FEE_DEPOSIT_30,
      45: FEE_DEPOSIT_45,
      50: FEE_DEPOSIT_50,
      80: FEE_DEPOSIT_80,
      120: FEE_DEPOSIT_120,
    };

    cart.items.forEach((item) => {
      // Sla fee/deposit variants zelf over
      if (FEE_VARIANT_IDS.has(item.variant_id)) return;

      const props = item.properties || {};
      const amountRaw = props["statiegeld_amount"];
      const hasStatiegeld = props["statiegeld"] === "yes";

      if (amountRaw !== undefined && amountRaw !== null && amountRaw !== "") {
        // Regel 1: statiegeld_amount aanwezig → gebruik bijpassende variant
        const amountKey = String(amountRaw).trim();
        const variantId = amountToVariant[amountKey];
        if (variantId) {
          productsByVariant[variantId].add(item.product_id);
          logDebug(
            `Statiegeld €${amountKey} voor product ${item.product_id} (variant ${variantId})`,
          );
        } else {
          logDebug(
            `⚠️ Onbekend statiegeld_amount "${amountRaw}" voor product ${item.product_id}, overgeslagen`,
          );
        }
      } else if (hasStatiegeld) {
        // Regel 2: geen amount, maar statiegeld=yes → standaard variant
        productsByVariant[FEE_DEPOSIT].add(item.product_id);
        logDebug(`Statiegeld default voor product ${item.product_id}`);
      }
    });

    const result = {
      deposit18Required: productsByVariant[FEE_DEPOSIT_18].size,
      deposit30Required: productsByVariant[FEE_DEPOSIT_30].size,
      deposit45Required: productsByVariant[FEE_DEPOSIT_45].size,
      deposit50Required: productsByVariant[FEE_DEPOSIT_50].size,
      deposit80Required: productsByVariant[FEE_DEPOSIT_80].size,
      deposit120Required: productsByVariant[FEE_DEPOSIT_120].size,
      depositDefaultRequired: productsByVariant[FEE_DEPOSIT].size,
    };

    logDebug("deposit requirements:", result);
    return result;
  }

  // Bepaal of de kantplank-stuk-fee nodig is.
  // Totaal > 0 én < 30 stuks van product KANTPLANK_PRODUCT_ID → 1x FEE_KANTPLANK_PIECES.
  function calculateKantplankRequirements(cart) {
    let totalQty = 0;

    cart.items.forEach((item) => {
      if (FEE_VARIANT_IDS.has(item.variant_id)) return;
      if (item.product_id === KANTPLANK_PRODUCT_ID) {
        totalQty += item.quantity;
      }
    });

    logDebug("Kantplank totaal aantal stuks:", totalQty);
    const kantplankRequired = totalQty > 0 && totalQty < 30 ? 1 : 0;
    logDebug("kantplankRequired:", kantplankRequired);

    return { kantplankRequired };
  }

  // Zet de hoeveelheid van de fee-variant gelijk aan requiredQty
  function setFeeQuantity(cart, variantId, requiredQty) {
    const feeItem = findFeeItem(cart, variantId);

    if (requiredQty <= 0) {
      if (!feeItem) return Promise.resolve(); // niets te verwijderen
      logDebug("fee naar 0 voor variant:", variantId);
      return fetch(window.Shopify.routes.root + "cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: feeItem.key, quantity: 0 }),
      })
        .then((r) => {
          if (!r.ok) {
            logError("cart/change.js response niet ok:", r.status, r.statusText);
            return r.text().then((text) => {
              logError("response body:", text);
              throw new Error("cart change failed");
            });
          }
          return r.json();
        })
        .then((data) => {
          logDebug("fee verwijderd:", variantId, data);
          return data;
        })
        .catch((err) => {
          logError("fout bij fee verwijderen:", err);
          throw err;
        });
    }

    if (!feeItem) {
      // nog geen fee, toevoegen met requiredQty
      logDebug("fee toevoegen variant:", variantId, "qty:", requiredQty);
      return fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: requiredQty }],
        }),
      })
        .then((r) => {
          if (!r.ok) {
            logError("cart/add.js response niet ok:", r.status, r.statusText);
            return r.text().then((text) => {
              logError("response body:", text);
              throw new Error("cart add failed - variant mogelijk niet beschikbaar");
            });
          }
          return r.json();
        })
        .then((data) => {
          logDebug("fee toegevoegd:", variantId, data);
          return data;
        })
        .catch((err) => {
          logError("fout bij fee toevoegen:", err);
          throw err;
        });
    }

    if (feeItem.quantity === requiredQty) {
      logDebug(
        "fee hoeveelheid al correct voor variant:",
        variantId,
        "qty:",
        requiredQty,
      );
      return Promise.resolve();
    }

    // Fee bestaat al: quantity bijwerken
    logDebug("fee quantity aanpassen voor variant:", variantId, "naar:", requiredQty);
    return fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: feeItem.key, quantity: requiredQty }),
    })
      .then((r) => {
        if (!r.ok) {
          logError("cart/change.js response niet ok:", r.status, r.statusText);
          return r.text().then((text) => {
            logError("response body:", text);
            throw new Error("cart change failed");
          });
        }
        return r.json();
      })
      .then((data) => {
        logDebug("fee aangepast:", variantId, data);
        return data;
      })
      .catch((err) => {
        logError("fout bij fee aanpassen:", err);
        throw err;
      });
  }

  function refreshCartUIIfNeeded(didChange) {
    if (!didChange) return;

    if (window.location.pathname.indexOf("/cart") === 0) {
      logDebug("cart UI refresh (page reload)");
      window.location.reload();
    } else {
      logDebug("cart UI refresh: side-cart herfetchen via ajaxCart.load");
      document.dispatchEvent(new CustomEvent("instelkosten:cart-updated"));
      // Gebruik ajaxCart.load (= updateCartPanel) om de side-cart opnieuw te fetchen.
      // Dit roept intern handleCartPanel → handleCartUpdates aan, zodat
      // de verwijder-knoppen correct worden herbonden aan het AJAX cart systeem.
      if (typeof ajaxCart !== "undefined" && typeof ajaxCart.load === "function") {
        ajaxCart.load(false, false, false, true);
      } else {
        // Fallback als ajaxCart nog niet beschikbaar is
        const sideCartContainer = document.getElementById("cart");
        if (sideCartContainer) {
          origFetch(window.Shopify.routes.root + "?section_id=side-cart")
            .then((r) => {
              if (!r.ok) return;
              return r.text();
            })
            .then((text) => {
              if (!text) return;
              const parsed = new DOMParser().parseFromString(text, "text/html");
              const newContent = parsed.querySelector("#shopify-section-side-cart");
              if (newContent) {
                logDebug("side-cart section bijgewerkt met fees (fallback)");
                sideCartContainer.innerHTML = newContent.innerHTML;
                window.dispatchEvent(new CustomEvent("listCart"));
              }
            })
            .catch((err) => logError("fout bij herfetchen side-cart:", err));
        }
      }
    }
  }

  function handleCartUpdate() {
    if (isUpdating) {
      logDebug("update overgeslagen (busy)");
      return;
    }
    isUpdating = true;
    logDebug("cart update gedetecteerd");

    fetch(window.Shopify.routes.root + "cart.js")
      .then((res) => {
        if (!res.ok) {
          logError("cart fetch status niet ok:", res.status);
          throw new Error("cart fetch failed");
        }
        return res.json();
      })
      .then((cart) => {
        logDebug("cart content:", cart);

        const { lowRequired, highRequired } = calculateFeeRequirements(cart);
        const { kantplankRequired } = calculateKantplankRequirements(cart);
        const {
          deposit18Required,
          deposit30Required,
          deposit45Required,
          deposit50Required,
          deposit80Required,
          deposit120Required,
          depositDefaultRequired,
        } = calculateDepositRequirements(cart);

        const lowItem = findFeeItem(cart, FEE_LOW);
        const highItem = findFeeItem(cart, FEE_HIGH);
        const kantplankItem = findFeeItem(cart, FEE_KANTPLANK_PIECES);
        const deposit18Item = findFeeItem(cart, FEE_DEPOSIT_18);
        const deposit30Item = findFeeItem(cart, FEE_DEPOSIT_30);
        const deposit45Item = findFeeItem(cart, FEE_DEPOSIT_45);
        const deposit50Item = findFeeItem(cart, FEE_DEPOSIT_50);
        const deposit80Item = findFeeItem(cart, FEE_DEPOSIT_80);
        const deposit120Item = findFeeItem(cart, FEE_DEPOSIT_120);
        const depositDefaultItem = findFeeItem(cart, FEE_DEPOSIT);

        const currentLowQty = lowItem ? lowItem.quantity : 0;
        const currentHighQty = highItem ? highItem.quantity : 0;
        const currentKantplankQty = kantplankItem ? kantplankItem.quantity : 0;
        const currentDeposit18Qty = deposit18Item ? deposit18Item.quantity : 0;
        const currentDeposit30Qty = deposit30Item ? deposit30Item.quantity : 0;
        const currentDeposit45Qty = deposit45Item ? deposit45Item.quantity : 0;
        const currentDeposit50Qty = deposit50Item ? deposit50Item.quantity : 0;
        const currentDeposit80Qty = deposit80Item ? deposit80Item.quantity : 0;
        const currentDeposit120Qty = deposit120Item ? deposit120Item.quantity : 0;
        const currentDepositDefaultQty = depositDefaultItem
          ? depositDefaultItem.quantity
          : 0;

        // Batch updates: verzamel alle changes
        const updates = {};

        if (currentLowQty !== lowRequired) {
          if (lowItem) {
            updates[lowItem.key] = lowRequired;
          } else if (lowRequired > 0) {
            updates[FEE_LOW] = lowRequired;
          }
        }

        if (currentHighQty !== highRequired) {
          if (highItem) {
            updates[highItem.key] = highRequired;
          } else if (highRequired > 0) {
            updates[FEE_HIGH] = highRequired;
          }
        }

        if (currentKantplankQty !== kantplankRequired) {
          if (kantplankItem) {
            updates[kantplankItem.key] = kantplankRequired;
          } else if (kantplankRequired > 0) {
            updates[FEE_KANTPLANK_PIECES] = kantplankRequired;
          }
        }

        if (currentDeposit18Qty !== deposit18Required) {
          if (deposit18Item) {
            updates[deposit18Item.key] = deposit18Required;
          } else if (deposit18Required > 0) {
            updates[FEE_DEPOSIT_18] = deposit18Required;
          }
        }

        if (currentDeposit30Qty !== deposit30Required) {
          if (deposit30Item) {
            updates[deposit30Item.key] = deposit30Required;
          } else if (deposit30Required > 0) {
            updates[FEE_DEPOSIT_30] = deposit30Required;
          }
        }

        if (currentDeposit45Qty !== deposit45Required) {
          if (deposit45Item) {
            updates[deposit45Item.key] = deposit45Required;
          } else if (deposit45Required > 0) {
            updates[FEE_DEPOSIT_45] = deposit45Required;
          }
        }

        if (currentDeposit50Qty !== deposit50Required) {
          if (deposit50Item) {
            updates[deposit50Item.key] = deposit50Required;
          } else if (deposit50Required > 0) {
            updates[FEE_DEPOSIT_50] = deposit50Required;
          }
        }

        if (currentDeposit80Qty !== deposit80Required) {
          if (deposit80Item) {
            updates[deposit80Item.key] = deposit80Required;
          } else if (deposit80Required > 0) {
            updates[FEE_DEPOSIT_80] = deposit80Required;
          }
        }

        if (currentDeposit120Qty !== deposit120Required) {
          if (deposit120Item) {
            updates[deposit120Item.key] = deposit120Required;
          } else if (deposit120Required > 0) {
            updates[FEE_DEPOSIT_120] = deposit120Required;
          }
        }

        if (currentDepositDefaultQty !== depositDefaultRequired) {
          if (depositDefaultItem) {
            updates[depositDefaultItem.key] = depositDefaultRequired;
          } else if (depositDefaultRequired > 0) {
            updates[FEE_DEPOSIT] = depositDefaultRequired;
          }
        }

        if (Object.keys(updates).length === 0) {
          logDebug("geen wijzigingen nodig");
          refreshCartUIIfNeeded(false);
          return;
        }

        logDebug("batch update:", updates);

        // Gebruik cart/update.js voor alle wijzigingen in één keer
        return fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates }),
        })
          .then((r) => {
            if (!r.ok) {
              logError("cart/update.js response niet ok:", r.status, r.statusText);
              return r.text().then((text) => {
                logError("response body:", text);
                throw new Error("cart update failed");
              });
            }
            return r.json();
          })
          .then((data) => {
            logDebug("batch update geslaagd:", data);
            refreshCartUIIfNeeded(true);
          })
          .catch((err) => {
            logError("fout bij batch update:", err);
          });
      })
      .catch((err) => logError("fout bij ophalen cart:", err))
      .finally(() => {
        isUpdating = false;
      });
  }

  // Intercept XHR
  const openOrig = window.XMLHttpRequest.prototype.open;
  window.XMLHttpRequest.prototype.open = function (method, url) {
    this._url = url;
    return openOrig.apply(this, arguments);
  };

  const sendOrig = window.XMLHttpRequest.prototype.send;
  window.XMLHttpRequest.prototype.send = function () {
    this.addEventListener("load", () => {
      if (
        this._url &&
        (this._url.match(/\/cart\/(add|change|update)(\.js)?/) ||
          this._url.match(/^\/cart\/change$/) ||
          this._url.match(/^\/cart\/update$/))
      ) {
        logDebug("XHR custom match:", this._url);
        handleCartUpdate();
      }
    });
    return sendOrig.apply(this, arguments);
  };

  // Intercept fetch
  const origFetch = window.fetch;
  window.fetch = function (...args) {
    const target = args[0];
    const url = typeof target === "string" ? target : target && target.url;
    logDebug("fetch called:", url);

    const isCartMutation =
      url &&
      (url.match(/\/cart\/(add|change|update)(\.js)?/) ||
        url.match(/^\/cart\/(add|change|update)$/));

    const promise = origFetch.apply(this, args);

    if (isCartMutation) {
      logDebug("fetch custom match:", url);
      return promise.then((resp) => {
        handleCartUpdate();
        return resp;
      });
    }

    return promise;
  };

  // Initial run
  function initialSync() {
    setTimeout(handleCartUpdate, 0);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialSync, { once: true });
  } else {
    initialSync();
  }

  if (window.location.pathname.indexOf("/cart") === 0) {
    setTimeout(handleCartUpdate, 500);
  }
})();